import { dateDiff, DatePrecision, getCurrentDate, getToday } from './date-time'

export class LogicalPath {
  public IsValidEmail(input: string) {
    const emailPattern =
      /^($|[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+|(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)))$/
    return emailPattern.test(input)
  }

  public RegexTest(input: string, pattern: string) {
    // Try with Unicode flag first, fall back to standard regex if it fails
    try {
      const regex = new RegExp(pattern, 'u')
      const res = regex.test(input)
      return res
    } catch (error) {
      // If Unicode flag causes issues (e.g., invalid Unicode escape), use standard regex
      const regex = new RegExp(pattern)
      const res = regex.test(input)
      return res
    }
  }

  public NewGuid() {
    return crypto.randomUUID()
  }

  public GetClinicToday() {
    return getToday()
  }

  public GetClinicNow() {
    return getCurrentDate()
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public DateDiff(precision: string, firstDate: any, secondDate: any): number {
    const convertedPrecision = this.convertDatePrecision(precision)
    if (firstDate && secondDate) {
      const diff = dateDiff(convertedPrecision, firstDate, secondDate)
      return Math.ceil(diff)
    }
    return 0
  }

  private convertDatePrecision(precision: string): DatePrecision {
    let res = null
    switch (precision) {
      case 'y':
        res = 'years'
        break
      case 'M':
        res = 'months'
        break
      case 'd':
        res = 'days'
        break
      case 'h':
        res = 'hours'
        break
      case 'm':
        res = 'minutes'
        break
      case 's':
        res = 'seconds'
        break
      default:
        throw new Error('convertDatePrecision, unsupported precision type, ' + precision)
    }

    return res as DatePrecision
  }
}
